import {FilterInput} from '../../../../components/lists/FilterInput';
import {ReduxListFilterStreamedContainer} from '../../../../core-utilities/redux/ReduxListContainer';
import {reduxList, componentOptions} from '../../redux/assetProjects';

export const AppNavigationAssetProjectsFilter = ReduxListFilterStreamedContainer(FilterInput, reduxList, componentOptions);



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationAssetProjects/AppNavigationAssetProjectsFilter.js